import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Hero } from './Hero.tsx';

// Render the application - check if root already exists to prevent double mounting
const rootElement = document.getElementById("cmkgdrd82009cwf0ybu6o3ras-root")!;
const rootKey = '_reactRoot' as const;

if (!(rootElement as any)[rootKey]) {
  const root = ReactDOM.createRoot(rootElement);
  (rootElement as any)[rootKey] = root;
  root.render(
    <React.StrictMode>
      <Hero />
    </React.StrictMode>
  );
}
